(function () {
    'use strict';

    ListingScheduleExportsController.$inject = ['$scope'];

    function ListingScheduleExportsController($scope) {
        const self = this;

        self.isLoading = false;
        self.isLocked = false;
        self.onReachBottom = async () => {
            if (self.isLocked) return;

            self.isLocked = true;
            self.isLoading = true;
            await self.getScheduleExports({sortType: self.sortType, isLoadMore: true});
            self.isLoading = false;
            self.isLocked = false;
            $scope.$digest();
        };

        self.scheduleHasInprogressRunStatus = (schedule) => {
            if (!schedule?.last_run_status) return false;

            return !!schedule.last_run_status.find((lastRun) => lastRun.status === 'IN_PROGRESS');
        };

        self.allChannelsWithoutStatus = (schedule) => {
            if (!schedule?.last_run_status) return false;

            return schedule.last_run_status.every((lastRun) => lastRun.status === null);
        };

        self.handleSort = (sortType) => {
            self.sortCol({sortType: sortType});
        };
    }

    angular
        .module('harriApp')
        .component('listingScheduleExports', {
            controller: ListingScheduleExportsController,
            controllerAs: '$ctrl',
            bindings: {
                schedules: '<',
                sortCol: '&',
                sortDirection: '<',
                sortType: '<',
                hasManageAllScheduleReportsPermission: '<',
                getLastRunStatusColor: '&',
                getLastRunTooltip: '&',
                getScheduleFormats: '&',
                deleteSchedule: '&',
                createEditExport: '&',
                getScheduleExports: '&',
                sortSchedules: '&',
                hasAccessOnHighestBrand: '<'
            },
            templateUrl: '../modules/hmap/report-scheduler/components/list-schedule-exports/list-schedule-exports.component.html'
        });
})();